export interface CloudDistanceDialogParams {
  pageName: string;
  map: string;
  selectDateFrom: string;
  selectDateTo: string;
  work: string[];
  deviceid: string[];
  judge: number;
  searchType: SearchType;
}

export enum SeriesType {
  OK = 'sum_okpoint',
  NG = 'sum_ngpoint',
  WARNING = 'sum_warningpoint'
}

export enum SearchType {
  WORK = 0, // 検査ごと
  HOUR = 1, // 1時間ごと
  DAY = 2, // 1日ごと
  MONTH = 3 // 1ヶ月ごと
}

export interface SearchConditions {
  selectDateFrom: string;
  selectDateTo: string;
  work: string[];
  map: string;
  deviceid: string[];
  judge: number;
  searchType: SearchType;
}

export interface CloudDistanceDigGraphBaseData {
  data_upper_distance: Array<number[] | number>; //検査毎の時はnumber
  data_lower_distance: Array<number[] | number>; //検査毎の時はnumber
  data_upper_limits: Array<number[] | number>; //検査毎の時はnumber
  data_lower_limits: Array<number[] | number>; //検査毎の時はnumber
  upper_distance_min: number;
  upper_distance_max: number;
  lower_distance_min: number;
  lower_distance_max: number;
  limits_min: number;
  limits_max: number;
  hasMultipleLimit: boolean;
  xlist: string[];
  detail: any[]; // listDataの行情報を持つ
  map: string;
}
